import type React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../../../store";
import {
  selectTruckHistory,
  selectTruckHistoryLoading,
  selectTruckHistoryPaginationForTruck,
} from "../../../store/features/truckHistorySlice";
import TruckRow from "./TruckRow";
import type { Truck } from "../../../types/truck";
import type { City } from "../../../types/city";

interface TruckRowWithHistoryProps {
  truck: Truck;
  isExpanded: boolean;
  onToggleRow: (truckId: string) => void;
  onAddHistory: (truckId: string) => void;
  getCityName: (cityId: string) => string;
  onTruckUpdate?: (truck: Truck) => void;
  cities: City[];
}

const TruckRowWithHistory: React.FC<TruckRowWithHistoryProps> = ({
  truck,
  isExpanded,
  onToggleRow,
  onAddHistory,
  getCityName,
  onTruckUpdate,
  cities,
}) => {
  const history = useSelector((state: RootState) => selectTruckHistory(state, truck._id));
  const loading = useSelector((state: RootState) => selectTruckHistoryLoading(state, truck._id));
  const pagination = useSelector((state: RootState) =>
    selectTruckHistoryPaginationForTruck(state, truck._id),
  );

  return (
    <TruckRow
      truck={truck}
      isExpanded={isExpanded}
      onToggleRow={onToggleRow}
      onAddHistory={onAddHistory}
      history={history}
      loading={loading}
      getCityName={getCityName}
      pagination={pagination}
      onTruckUpdate={onTruckUpdate}
      cities={cities}
    />
  );
};

export default TruckRowWithHistory;
